// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-mobrgY"};